if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      /**
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // const formData = new FormData(this.form);

        // --- 【修改开始】 ---
        const formData = new FormData(this.form);
        
        // 检查页面上是否有勾选的加购项
        const checkedUpsells = document.querySelectorAll('.addon-checkbox:checked');
        
        if (checkedUpsells.length > 0) {
          // console.log('[Bundle] 检测到加购项，正在重组数据...');
          console.log('upsell adding', 'this.cart', this.cart)

          // 无论是在 cart-drawer 还是 main-cart 页面，都可以用 data-line-key 提取
          const cartItemEls = (this.cart || document).querySelectorAll('[data-line-key]');
          const cartIds = Array.from(cartItemEls).map(el => parseInt(el.getAttribute('data-line-key')));
          
          // 1. 先把当前主产品的 ID 和 数量 存下来
          const mainId = formData.get('id');
          const mainQty = formData.get('quantity') || 1;
          
          // 2. 清除 formData 里的原始 id 和 quantity，防止冲突
          formData.delete('id');
          formData.delete('quantity');
          
          // 3. 重新以 items 数组格式注入主产品
          formData.append('items[0][id]', mainId);
          formData.append('items[0][quantity]', mainQty);
          
          // 4. 循环注入勾选的副产品
          // const checkedItems = Array.from(checkedUpsells);
          // checkedItems.forEach((checkbox, index) => {
          //   const vid = checkbox.getAttribute('data-upsell-id');
          //   const vqty = checkbox.getAttribute('data-upsell-qty') || 1;
            
          //   // 索引从 1 开始，因为 0 给了主产品
          //   formData.append(`items[${index + 1}][id]`, vid);
          //   formData.append(`items[${index + 1}][quantity]`, vqty);
          //   // console.log(`[Bundle] 已加入副产品 ID: ${vid}`);
          // });
          // 3. 循环注入勾选的副产品
          let addedIndex = 1; // 单独维护索引
          
          Array.from(checkedUpsells).forEach((checkbox) => {
            const vid = parseInt(checkbox.getAttribute('data-upsell-id'));
            const vqty = checkbox.getAttribute('data-upsell-qty') || 1;
            const isLimitOne = checkbox.getAttribute('data-limit-one') === 'true'; // 依然需要 liquid 配合传这个标记
            
            // 🎯 核心过滤逻辑：如果限购且购物车 DOM 里已经有它了，跳过！
            if (isLimitOne && cartIds.includes(vid)) {
              console.log(`[Bundle] 赠品 ${vid} 已在购物车内，拦截重复添加`);
              return; 
            }

            formData.append(`items[${addedIndex}][id]`, vid);
            formData.append(`items[${addedIndex}][quantity]`, vqty);
            addedIndex++;
          });
        }
        // --- 【修改结束】 ---

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }
      */

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const checkedUpsells = document.querySelectorAll('.addon-checkbox:checked');
        
        if (checkedUpsells.length > 0) {
          // 💡 核心修复：如果有多件商品，切换为 JSON 请求格式
          config.headers['Content-Type'] = 'application/json';
          
          const cartItemEls = (this.cart || document).querySelectorAll('[data-line-key]');
          const cartIds = Array.from(cartItemEls).map(el => parseInt(el.getAttribute('data-line-key')));
          
          const items =[];
          
          // 1. 提取主产品数据 (同时保留可能存在的 properties 定制属性)
          const mainProduct = {
            id: parseInt(formData.get('id')),
            quantity: parseInt(formData.get('quantity') || 1),
            properties: {}
          };
          for (let [key, value] of formData.entries()) {
            if (key.startsWith('properties[')) {
              let propName = key.match(/\[(.*?)\]/)[1];
              mainProduct.properties[propName] = value;
            }
          }
          items.push(mainProduct);
          
          // 2. 提取并过滤赠品/副产品
          Array.from(checkedUpsells).forEach((checkbox) => {
            const vid = parseInt(checkbox.getAttribute('data-upsell-id'));
            const vqty = parseInt(checkbox.getAttribute('data-upsell-qty') || 1);
            const isLimitOne = checkbox.getAttribute('data-limit-one') === 'true';
            
            // 拦截：限购且已经在购物车中
            if (isLimitOne && cartIds.includes(vid)) {
              console.log(`[Bundle] 赠品 ${vid} 已在购物车内，拦截重复添加`);
              return; 
            }
            items.push({ id: vid, quantity: vqty });
          });

          // 3. 构建 JSON Payload
          const payload = { items: items };

          // 把 sections 参数合并进 JSON 中
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((s) => s.id).join(',');
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          
          config.body = JSON.stringify(payload);

        } else {
          // 如果没有勾选副产品，维持原有的 FormData 单商品请求逻辑
          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        // 发起请求
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'), // 依然从 formData 拿主 id，防止报错
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response); // <--- 这里就是刷新气泡和抽屉的地方！
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
